import React from 'react';

import { TFunction } from 'next-i18next';
import {
  Button,
  LoadingSpinner,
  Text,
} from '@thinkific/chalk/react-components';
import { Attachment } from 'schema/Post/types';
import { File, FilePdf, FileZip, X } from '@thinkific/chalk/react-icons';
import { getFileExtension } from 'utils/fileHelper';
import styles from './FilePreview.module.scss';

interface FilePreviewProps {
  attachment: Attachment;
  onRemove: () => void;
  t: TFunction; // Would be better to pass in the translated strings used here
}

export const getFileIcon = (fileType: string) => {
  switch (fileType) {
    case 'pdf':
      return <FilePdf size="lg" />;
    case 'zip':
      return <FileZip size="lg" />;
    default:
      return <File size="lg" />;
  }
};

const FilePreview = ({ attachment, onRemove, t }: FilePreviewProps) => {
  const { fileName, isLoading } = attachment;

  const fileType = getFileExtension(fileName);
  const fileIcon = getFileIcon(fileType);

  return (
    <div
      aria-live="polite"
      className={styles['file-preview']}
      data-qa="file-attachment__file-preview"
      id="file-attachment-preview"
      key={attachment.url}
      role="region"
      title={t('File Preview')}
    >
      {fileIcon}
      <Text className={styles['file-preview__name']} title={fileName}>
        {fileName}
      </Text>
      {isLoading ? (
        <div className={styles['loading-spinner-button']}>
          <LoadingSpinner
            data-qa="file-attachment__loading-spinner"
            size="sm"
            onDark
          />
        </div>
      ) : (
        <Button
          className={styles['remove-file-button']}
          data-qa="file-attachment__remove-button"
          icon={X}
          size="xs"
          hiddenLabel
          onClick={onRemove}
        >
          {t('Remove', 'Remove')}
        </Button>
      )}
    </div>
  );
};

export default FilePreview;
